import { Voter } from '../voter';

export class VersionVoter extends Voter {
    constructor(constraints) {
        super();
        this.constraints = constraints;
    }

    supports(request) {
        return !!this.constraints[request.resource];
    }

    vote(request) {
        if (!this.supportsVersion(request, this.constraints[request.resource])) {
            return false;
        }

        // returning undefined here means 'abstain' from voting
        // so, we restrict permission if version check fails by returning 'false',
        // and 'abstain' from voting (essentially allowing the other voters to decide) otherwise by returning 'undefined'
    }
}
